import React, { useEffect, useState } from "react";
import ENDPOINT from "../../context/EndPoint";
import axios from "axios";
import logo from "../../assets/skillsuprise.png"

const WhatsappPanel = () => {
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
const [toast, setToast] = useState({
  show: false,
  message: "",
  type: "success"
});

const [sendingId, setSendingId] = useState(null);

const [bulkSending, setBulkSending] = useState(false);



  const getUsers = async () => {
    try {
      const res = await axios.get( ENDPOINT + "whatsapp/get-whatsapp-users.php");
      setUsers(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);



  const toggleUserSelection = (id) => {

    if (selectedUsers.includes(id)) {
  
      setSelectedUsers(
        selectedUsers.filter(userId => userId !== id)
      );
  
    } else {
  
      setSelectedUsers([
        ...selectedUsers,
        id
      ]);
  
    }
  
  };

  const toggleSelectAll = () => {

    if (selectAll) {
  
      setSelectedUsers([]);
  
      setSelectAll(false);
  
    } else {
  
      const allUserIds = filteredUsers.map(user => user.id);
  
      setSelectedUsers(allUserIds);
  
      setSelectAll(true);
  
    }
  
  };

  const sendMessage = async (id, name) => {

    try {
  
      // 🔥 CHANGE BUTTON TO SENDING
      setSendingId(id);
  
      const formData = new FormData();
  
      formData.append("user_id", id);
  
      formData.append("message", message);

      if (selectedImage) {

        formData.append("image", selectedImage);
      
      }
  
      await axios.post(
        ENDPOINT + "whatsapp/send-whatsapp-message.php",
        formData
      );
  
      // 🔥 CHANGE BUTTON TO SENT
      setSendingId("sent_" + id);
  
      setToast({
        show: true,
        message: `Message sent successfully to ${name}`,
        type: "success"
      });
  
      getUsers();
  
      // 🔥 AFTER 1 SECOND RETURN TO NORMAL
      setTimeout(() => {
        setSendingId(null);
      }, 1000);
  
    } catch (error) {
  
      console.log(error);
  
      setSendingId(null);
  
      setToast({
        show: true,
        message: `Failed to send message to ${name}`,
        type: "danger"
      });
  
    }
  
    setTimeout(() => {
  
      setToast({
        show: false,
        message: "",
        type: "success"
      });
  
    }, 3000);

    if (!selectedImage) {

      setToast({
        show: true,
        message: "Please select image",
        type: "danger"
      });
    
      return;
    }
  
  };

  const sendBulkMessages = async () => {

    if (selectedUsers.length === 0) {
  
      setToast({
        show: true,
        message: "Please select users before sending messages",
        type: "danger"
      });
  
      setTimeout(() => {
        setToast({
          show: false,
          message: "",
          type: "danger"
        });
      }, 3000);
  
      return;
    }
  
    try {
      setBulkSending(true);
  
      for (let i = 0; i < selectedUsers.length; i++) {
  
        const userId = selectedUsers[i];
  
        const formData = new FormData();
  
        formData.append("user_id", userId);
        formData.append("message", message);

        if (selectedImage) {

          formData.append("image", selectedImage);
        
        }
  
        await axios.post(ENDPOINT+ "whatsapp/send-whatsapp-message.php",formData);
  
        // 🔥 DELAY 1.5 sec between messages
        await new Promise(resolve =>
          setTimeout(resolve, 1500)
        );
  
      }
  
      setToast({
        show: true,
        message: `Messages sent to ${selectedUsers.length} users`,
        type: "success"
      });
      setSelectedUsers([]);

      getUsers();
      
      // 🔥 SHOW SENT FOR 1 SEC
      setBulkSending("sent");
      
      setTimeout(() => {
        setBulkSending(false);
      }, 1000);
  
    } catch (error) {
  
      console.log(error);

      setBulkSending(false);
  
      setToast({
        show: true,
        message: "Bulk sending failed",
        type: "danger"
      });
  
    }
  
    setTimeout(() => {
      setToast({
        show: false,
        message: "",
        type: "success"
      });
    }, 3000);

    if (!selectedImage) {

      setToast({
        show: true,
        message: "Please select image",
        type: "danger"
      });
    
      return;
    }

  };

  // Filter users based on search
  const filteredUsers = users.filter(user =>
    user.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.phone_number?.includes(searchTerm)
  );

  useEffect(() => {

    if (
      filteredUsers.length > 0 &&
      selectedUsers.length === filteredUsers.length
    ) {
  
      setSelectAll(true);
  
    } else {
  
      setSelectAll(false);
  
    }
  
  }, [selectedUsers, filteredUsers]);

  return (
    <div className="container-fluid h-100 p-3" style={{ backgroundColor: "#f0f2f5" }}>
      <div className="card shadow-lg" style={{ borderRadius: "12px", overflow: "hidden" }}>
        
        {/* Header */}
        <div className="card-header bg-success text-white py-3">
        <div className="d-flex align-items-center">
            <div className="bg-white text-success rounded-circle d-flex align-items-center justify-content-center me-3" 
                 style={{ width: "40px", height: "40px", fontSize: "20px" }}>
              <img src={logo} alt="WhatsApp" style={{ width: "30px", height: "30px", fontSize: "20px" }} />
            </div>
            <div>
              <h4 className="mb-0 text-white">WhatsApp Marketing</h4>
              <small>Send messages to multiple users</small>
            </div>
          </div>
        </div>

        <div className="row h-100 g-0">

          {/* Left Sidebar - Users List */}
          <div className="col-lg-5 col-xl-4 border-end bg-white" style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}>
          <div className="p-3 border-bottom">

<div className="input-group">

  <span className="input-group-text bg-light">
    <i className="bi bi-search"></i>
  </span>

  <input
    type="text"
    className="form-control"
    placeholder="Search by name or phone..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />

</div>

{/* SELECT ALL */}

<div className="d-flex align-items-center justify-content-between mt-3">

  <div className="form-check">

    <input
      type="checkbox"
      className="form-check-input"
      checked={selectAll}
      onChange={toggleSelectAll}
      id="selectAllUsers"
    />

    <label
      className="form-check-label fw-semibold ms-2"
      htmlFor="selectAllUsers"
    >
      Select All Users
    </label>

  </div>

  <small className="text-muted">

    {selectedUsers.length} Selected

  </small>

</div>

</div>

            <div className="list-group list-group-flush">
              {filteredUsers.map((user) => (
                <div key={user.id} className="list-group-item list-group-item-action p-3 hover-bg-light">
                  <div className="d-flex align-items-center">
                  <input
  type="checkbox"
  className="form-check-input me-3"
  checked={selectedUsers.includes(user.id)}
  onChange={() => toggleUserSelection(user.id)}
/>
                    <div className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center me-3"
                         style={{ width: "50px", height: "50px", fontSize: "18px" }}>
                      {user.full_name?.charAt(0).toUpperCase()}
                    </div>

                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="mb-1">{user.full_name}</h6>
                        <small className="text-muted">{user.phone_number}</small>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted">{user.email}</small>
                        <span className={`badge ${user.message_status === 'Sent' ? 'bg-success' : 'bg-secondary'}`}>
                          {user.message_status || "Not Sent"}
                        </span>
                      </div>
                      {user.message_datetime && (
                        <small className="text-muted">Sent: {user.message_datetime}</small>
                      )}
                    </div>

                    <button
  className={`btn btn-sm ms-3 px-4 ${
    sendingId === "sent_" + user.id
      ? "btn-primary"
      : "btn-success"
  }`}
  onClick={() => sendMessage(user.id, user.full_name)}
>

  {
    sendingId === user.id
      ? "Sending..."
      : sendingId === "sent_" + user.id
      ? "Sent ✓"
      : "Send"
  }

</button>
                  </div>
                </div>
              ))}

              {filteredUsers.length === 0 && (
                <div className="text-center text-muted py-5">
                  No users found
                </div>
              )}
            </div>
          </div>

          {/* Right Side - Message Composer */}
          <div className="col-lg-7 col-xl-8 d-flex flex-column bg-light" >
            
            {/* Chat Header */}
            <div className="bg-white border-bottom p-3">
              <h5 className="mb-1">Message Composer</h5>
              <small className="text-muted">Type your message once and send to any user from the list</small>
            </div>

            {/* Message Preview Area */}
            {/* Message Preview Area */}

<div
  className="flex-grow-1 p-4 overflow-auto"
  style={{ maxHeight: "calc(100vh - 280px)" }}
>

  {
    imagePreview || message ? (

      <div
        className="bg-white p-2 rounded-4 shadow-sm ms-auto"
        style={{
          maxWidth: "380px",
          width: "fit-content"
        }}
      >

        {/* IMAGE PREVIEW */}

        {
          imagePreview && (

            <div className="position-relative">

              <img
                src={imagePreview}
                alt="Preview"
                className="img-fluid rounded-4"
                style={{
                  maxHeight: "350px",
                  objectFit: "cover",
                  width: "100%"
                }}
              />

              {/* REMOVE IMAGE BUTTON */}

              <button
                className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2 rounded-circle"
                onClick={() => {

                  setSelectedImage(null);

                  setImagePreview(null);

                }}
              >
                ✕
              </button>

            </div>

          )
        }

        {/* TEXT PREVIEW */}

        {
          message && (

            <div
              className="bg-success text-white p-3 rounded-3 mt-2"
              style={{
                borderBottomRightRadius: "4px"
              }}
            >
              {message}
            </div>

          )
        }

      </div>

    ) : (

      <div className="h-100 d-flex align-items-center justify-content-center text-muted">

        <div className="text-center">

          <i className="bi bi-chat-text display-4 mb-3"></i>

          <p>Select image and preview will appear here</p>

        </div>

      </div>

    )
  }

</div>

            {/* Message Input Area (WhatsApp Style) */}
            <div className="bg-white border-top p-3">
            <div className="mb-3">

            <input
  type="file"
  accept="image/*"
  className="form-control"
  onChange={(e) => {

    const file = e.target.files[0];

    setSelectedImage(file);

    if (file) {

      setImagePreview(URL.createObjectURL(file));

    }

  }}
/>

</div>
              <textarea
                className="form-control mb-3"
                rows="4"
                placeholder="Type your message here..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={{ resize: "none", borderRadius: "12px" }}
              />

              <div className="d-flex justify-content-between align-items-center">
                <small className="text-muted">
                  {message.length}/1000 characters
                </small>
                <button
  className={`btn px-4 ${
    bulkSending === "sent"
      ? "btn-primary"
      : "btn-success"
  }`}
  onClick={sendBulkMessages}
>
{
  bulkSending === true ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
      ></span>
      Sending...
    </>
  ) : bulkSending === "sent" ? (
    <>
      <i className="bi bi-check-circle me-2"></i>
      Sent ✓
    </>
  ) : (
    <>
      <i className="bi bi-send me-2"></i>
      Send to {selectedUsers.length || 0} Users
    </>
  )
}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
  toast.show && (
    <div
      className={`toast show position-fixed bottom-0 end-0 m-4 text-white bg-${toast.type}`}
      style={{
        zIndex: 9999,
        minWidth: "300px",
        borderRadius: "12px"
      }}
    >
      <div className="toast-body d-flex justify-content-between align-items-center">
        <span>{toast.message}</span>

        <button
          className="btn-close btn-close-white"
          onClick={() =>
            setToast({
              show: false,
              message: "",
              type: "success"
            })
          }
        />
      </div>
    </div>
  )
}
    </div>
  );
};

export default WhatsappPanel;